// EmailJS Configuration
// Follow these steps to set up EmailJS:

/*
SETUP INSTRUCTIONS:

1. Go to https://www.emailjs.com/ and create a free account
2. Add an email service (Gmail, Outlook, etc.)
3. Create an email template
4. Get your Service ID, Template ID, and Public Key
5. Replace the values below with your actual EmailJS credentials

EMAIL TEMPLATE EXAMPLE:
Subject: New Contact from Portfolio: {{subject}}

Hello Urvansh,

You have received a new message through your portfolio website:

From: {{from_name}} ({{from_email}})
Subject: {{subject}}

Message:
{{message}}

---
Sent from your portfolio contact form
Website: urvanshshah.netlify.app
*/

export const emailConfig = {
  // Your EmailJS credentials
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_h0kn4cs',
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_7fdm1z6',
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'kWQLHD1MSR5To6ATn',

  // Your email where messages will be sent
  toEmail: 'urvanshshah9@gmail.com',

  // Email template variables (these match the template you create in EmailJS)
  templateParams: {
    from_name: '',      // Will be filled from form
    from_email: '',     // Will be filled from form
    subject: '',        // Will be filled from form
    message: '',        // Will be filled from form
    to_email: 'urvanshshah9@gmail.com'
  }
};

// Check if EmailJS is properly configured
export const isEmailJSConfigured = () => {
  return emailConfig.serviceId !== 'SETUP_REQUIRED' &&
         emailConfig.templateId !== 'SETUP_REQUIRED' &&
         emailConfig.publicKey !== 'SETUP_REQUIRED' &&
         emailConfig.serviceId !== 'YOUR_SERVICE_ID' &&
         emailConfig.templateId !== 'YOUR_TEMPLATE_ID' &&
         emailConfig.publicKey !== 'YOUR_PUBLIC_KEY';
};

// Validation patterns
export const validationPatterns = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  name: /^[a-zA-Z\s]{2,50}$/,
  subject: /^.{3,100}$/,
  message: /^.{10,1000}$/
};

// Error messages
export const errorMessages = {
  name: {
    required: 'Name is required',
    invalid: 'Name should contain only letters and spaces (2-50 characters)'
  },
  email: {
    required: 'Email is required',
    invalid: 'Please enter a valid email address'
  },
  subject: {
    required: 'Subject is required',
    invalid: 'Subject should be 3-100 characters long'
  },
  message: {
    required: 'Message is required',
    invalid: 'Message should be 10-1000 characters long'
  }
};

// Success messages
export const successMessages = {
  emailSent: '✅ Message sent successfully! I\'ll get back to you soon.',
  formReset: 'Form has been reset'
};

// Loading messages
export const loadingMessages = {
  sending: 'Sending your message...',
  processing: 'Processing...'
};

export default emailConfig;
